define('adminPhrasesCreateEditView',[
  'module',
  'underscore',
  'marionette',
  'backbone',
  'jquery',
  'dialogFormView',
  'template!adminPhrasesCreateEditTpl',
  'savingBehavior',
  'dynamicTextView'
], function (
  module,
  _,
  Marionette,
  Backbone,
  $,
  DialogFormView,
  createEditLayoutTpl,
  SavingBehavior,
  DynamicTextView
) {
  'use strict';

  var CreateEditLayoutView = DialogFormView.extend({
    template: createEditLayoutTpl,

    ui: {
      input: '.js-info-input'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input': 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm'
    },

    regions: {
      internalNameRegion: '.internal-name-region',
      emailTextRegion: '.email-text-region',
      proofsheetTextRegion: '.proofsheet-text-region'
    },

    className: 'profile-create-edit',

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
      {name: 'code', type: 'required'}
    ],

    initialize: function (options) {
      this.model = options.phraseModel;
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onShow: function () {
      $.material.init();

      this.internalNameDtView = new DynamicTextView({
        model: this.model.get('internalName'),
        noSaving: true,
        hideGlossary: true
      });
      this.internalNameDtView.dataUpdated = _.bind(function () {
        this.triggerMethod('enable:cancel:confirm');
      }, this);
      this.getRegion('internalNameRegion').show(this.internalNameDtView);

      this.emailTextDtView = new DynamicTextView({
        model: this.model.get('emailText'),
        noSaving: true,
        hideGlossary: true,
        textAreaMode: true
      });
      this.emailTextDtView.dataUpdated = _.bind(function () {
        this.triggerMethod('enable:cancel:confirm');
      }, this);
      this.getRegion('emailTextRegion').show(this.emailTextDtView);

      this.proofsheetTextDtView = new DynamicTextView({
        model: this.model.get('proofsheetText'),
        noSaving: true,
        hideGlossary: true,
        textAreaMode: true
      });
      this.proofsheetTextDtView.dataUpdated = _.bind(function () {
        this.triggerMethod('enable:cancel:confirm');
      }, this);
      this.getRegion('proofsheetTextRegion').show(this.proofsheetTextDtView);
    },

    onConfirm: function () {
      this.model.save();
    },

    onSave: function () {
      this.model = null;
      this.triggerMethod('saved');
      this.hide();
    },

    onSaveError: function (model, response) {
      if (response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    }
  });

  module.exports = CreateEditLayoutView;
});

